import { render, staticRenderFns } from "./AdminBannersList.vue?vue&type=template&id=c2f6e93c"
import script from "./AdminBannersList.vue?vue&type=script&lang=js"
export * from "./AdminBannersList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports